import React, { useEffect, useMemo, useState } from "react";
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { isEmpty } from "lodash";
import '../../../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import TableContainer from '../../../components/Common/TableContainer';
import * as Yup from "yup";
import { useFormik } from "formik";

//import components
import Breadcrumbs from '../../../components/Common/Breadcrumb';
import PageHint from '../../../components/Common/PageHint';
import DeleteModal from '../../../components/Common/DeleteModal';
import LangModal from '../../../components/Common/LangModal';
import RecipeStepsLang from '../../../components/Common/RecipeStepsLang';
import MultiSelectOption from "../MultiSelectOption";
import "jspdf-autotable";
import * as XLSX from 'xlsx';

import {
  addRecipes as onAddRecipes,
  updateRecipes as onUpdateRecipes,
  getRecipes as onGetRecipes,
  deleteRecipes as onDeleteRecipes
} from "store/contacts/actions";

import axios from 'axios';

import { Name } from "./EcommerceOrderCol";
import 'react-dropzone-uploader/dist/styles.css'
import Dropzone from 'react-dropzone-uploader';

//redux
import { useSelector, useDispatch } from "react-redux";
import EcommerceOrdersModal from "./EcommerceOrdersModal";

import {
  Col,
  Row,
  UncontrolledTooltip,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  Input,
  FormFeedback,
  Label,
  Card,
  CardBody,
  Progress,
} from "reactstrap";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import { makeUploadParams } from "../../../helpers/imageResize";

function EcommerceOrder() {
  document.title = "Tarifler | Buhara - Admin Paneli";

  const [getFileNameMobile, setFileNameMobile] = useState(null);
  const [getFileNameLogo, setFileNameLogo] = useState(null);
  const [getProductList, setProductList] = useState([]);
  const [getSelectProduct, setSelectProduct] = useState([]);

  const [getSelectGramList, setSelectGramList] = useState([]);
  const [getGramList, setGramList] = useState([]);
  const [getBlogList, setBlogList] = useState([]);

  const [getIsAddMaking, setIsAddMaking] = useState(false);
  const [getMakingList, setMakingList] = useState([]);
  const [getCountStep, setCountStep] = useState(1);

  // Tarif medyası: tek video + sınırsız galeri görseli.
  const [getFileNameVideo, setFileNameVideo] = useState(null);
  // Galeri elemanı: { ID: kayıtlıysa Recipes_ImageNew.ID, name: dosya adı }
  const [getGalleryImages, setGalleryImages] = useState([]);

  // Görseller sunucuya gitmeden önce tarayıcıda küçültülür (helpers/imageResize).
  const getUploadParams = makeUploadParams('https://buharaadmin.stechomeyazilim.info:8099/uploadfile');

  const handleChangeStatusLogo = ({ xhr }) => {
    if (xhr) {
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          const result = JSON.parse(xhr.response);
          setFileNameLogo(result.file.filename)
        }
      }
    }
  }

  const handleChangeStatusMobile = ({ xhr }) => {
    if (xhr) {
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          const result = JSON.parse(xhr.response);
          setFileNameMobile(result.file.filename)
        }
      }
    }
  }

  // Video yüklendiğinde dosya adını sakla (tarif başına tek video).
  const handleChangeStatusVideo = (fileWithMeta, status) => {
    if (status !== 'done') return;
    try {
      const result = JSON.parse(fileWithMeta.xhr.response);
      if (result?.file?.filename) setFileNameVideo(result.file.filename);
    } catch (err) { console.error("Video yükleme hatası:", err); }
  }

  // Galeri: her yüklenen görseli listeye ekle, dropzone'u boşalt ki
  // istenen sayıda görsel arka arkaya eklenebilsin (adet sınırı yok).
  const handleChangeStatusGallery = (fileWithMeta, status) => {
    if (status !== 'done') return;
    try {
      const result = JSON.parse(fileWithMeta.xhr.response);
      const filename = result?.file?.filename;
      if (filename) setGalleryImages(prev => [...prev, { ID: null, name: filename }]);
    } catch (err) { console.error("Galeri yükleme hatası:", err); }
    fileWithMeta.remove();
  }

  // --- API ÇAĞRILARI ---
  const _getGramList = async () => {
    try {
      const res = await axios.get(`https://buharaapi.stechomeyazilim.info/Products_Units`);
      // OData yanıtı { value: [...] } biçiminde gelir; diziyi oradan al.
      const list = Array.isArray(res.data) ? res.data : (res.data?.value || []);
      const mapped = list.map(item => ({ label: item.Products_Units_Text, value: item.ID }));
      setGramList(mapped);
    } catch (err) { console.error(err); }
  }

  const _getProductList = async () => {
    try {
      const res = await axios.get(`https://buharaapi.stechomeyazilim.info/Products2`);
      const list = Array.isArray(res.data) ? res.data : (res.data?.value || []);
      // Açılır listede "Ürün Adı + Unit2" göster (örn. "Karabiber Çay kaşığı").
      const mapped = list.map(item => ({
        label: `${item.Products_Name || ""}${item.Products2_UnitText2 ? " " + item.Products2_UnitText2 : ""}`,
        value: item.ID,
        amount: item.Products_Amount,
        piece: item.Products_Piece,
        unitText: item.Products2_UnitText,
        unit2: item.Products2_UnitText2,
      }));
      setProductList(mapped);
    } catch (err) { console.error(err); }
  }

  const [getCategoryList, setCategoryList] = useState([]);
  const _getCategoryList = async () => {
    try {
      const res = await axios.get(`https://buharaapi.stechomeyazilim.info/Recipes_Category`);
      const list = Array.isArray(res.data) ? res.data : (res.data?.value || []);
      setCategoryList(list.map(item => ({ label: item.Recipes_Category_Text, value: item.ID })));
    } catch (err) { console.error(err); }
  }

  const _getBlogList = async () => {
    try {
      const res = await axios.get(`https://buharaapi.stechomeyazilim.info/Blog`);
      const list = Array.isArray(res.data) ? res.data : (res.data?.value || []);
      const mapped = list.map(item => ({ label: item.Blog_Title, value: item.ID }));
      setBlogList(mapped);
    } catch (err) { console.error(err); }
  }

  useEffect(() => {
    _getProductList();
    _getGramList();
    _getBlogList();
    _getCategoryList();
  }, []);

  const [modal, setModal] = useState(false);
  const [modal1, setModal1] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [getMakingText, setMakingText] = useState(null);

  const [orderList, setOrderList] = useState([]);
  const [order, setOrder] = useState(null);
  const [getOrderProduct, setOrderProduct] = useState(null);
  const [getOrderBlog, setOrderBlog] = useState(null);

  const [getEditSlider, setEditSlider] = useState(null);
  const [getIsEditAddProduct, setIsEditAddProduct] = useState(false);
  const [getIsAddBlog, setIsAddBlog] = useState(false);
  const [getSelectBlog, setSelectBlog] = useState([]);
  const [getIsActiveTrend, setIsActiveTrend] = useState(false);

  const dispatch = useDispatch();

  // Adımlar panelde sıra numarasına göre gösterilip kaydedilir.
  const sortedMaking = (recipe) =>
    [...((recipe && recipe.Recipes_Making) || [])].sort(
      (a, b) => (a.Recipes_Making_Sort ?? 0) - (b.Recipes_Making_Sort ?? 0) || a.ID - b.ID
    );

  // PATCH başarısızsa eski backend 200 + `false` dönüyordu; bunu da hata say.
  const mustPatch = async (url, data) => {
    const res = await axios.patch(url, data);
    if (res && res.data === false) throw new Error("Sunucu kaydı güncelleyemedi.");
    return res;
  };

  // Web sitesinin önbelleğini boşaltır; değişiklik sitede hemen görünür
  // (aksi halde site sayfayı 5 dakikaya kadar eski hâliyle sunuyor).
  // Mobil uygulama veriyi her açılışta API'den çektiği için ek işlem gerekmez.
  const refreshSite = async () => {
    const key = process.env.REACT_APP_REVALIDATE_KEY;
    if (!key) return;
    const site = process.env.REACT_APP_SITE_URL || "https://www.buhara.com";
    try {
      await fetch(`${site}/api/revalidate`, { method: "POST", headers: { "x-revalidate-key": key } });
    } catch (e) {
      console.warn("Site önbelleği yenilenemedi:", e);
    }
  };
  const { orders } = useSelector(state => ({
    orders: state.contacts.recipesR,
  }));

  // Tarifleri SADECE bir kez çek. (Eski kod: orders boşken sürekli dispatch edip
  // sonsuz döngüye giriyordu; tablo boş olunca sunucuyu 504'e boğuyordu.)
  useEffect(() => {
    dispatch(onGetRecipes());
    setIsEdit(false);
  }, [dispatch]);

  // Redux'taki liste değişince tabloyu güncelle.
  useEffect(() => {
    setOrderList(orders || []);
  }, [orders]);

  // --- ANA FORMIK YAPISI (Tek Seferde Ekleme İçin Geliştirildi) ---
  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      recipesName: (getEditSlider && getEditSlider.Recipes_Title) || '',
      shortDesc: (getEditSlider && getEditSlider.Recipes_ShortText) || '',
      cookingTime: (getEditSlider && getEditSlider.Recipes_Cooking_Time) || '',
      prepationTime: (getEditSlider && getEditSlider.Recipes_Preparation_Time) || '',
      longDesc: (getEditSlider && getEditSlider.Recipes_Desc) || '',
      categoryId: (getEditSlider && getEditSlider.Recipes_Category_ID) || '',
      energy: (getEditSlider && getEditSlider.Recipes_Energy) || '',
      carbohydrate: (getEditSlider && getEditSlider.Recipes_Carbohydrate) || '',
      protein: (getEditSlider && getEditSlider.Recipes_Protein) || '',
      oil: (getEditSlider && getEditSlider.Recipes_Oil) || '',
      ingredients: (getEditSlider && getEditSlider.Recipes_Products && getEditSlider.Recipes_Products.length > 0)
        ? getEditSlider.Recipes_Products.map(p => ({
            // row_id: mevcut Recipes_Products kaydı — kaydederken bu satır
            // silinip yeniden yazılmaz, yerinde güncellenir (bkz. onSubmit).
            row_id: p.ID,
            product_id: p.Products2_ID || p.Product_ID || '',
            amount: p.Products_Unit_Input || ''
          }))
        : [{ product_id: '', amount: '' }],
      steps: (getEditSlider && getEditSlider.Recipes_Making && getEditSlider.Recipes_Making.length > 0)
        ? sortedMaking(getEditSlider).map(s => s.Recipes_Making_Title)
        : [''],
    },
    validationSchema: Yup.object({
      recipesName: Yup.string().required("Tarif Başlığını Giriniz"),
      longDesc: Yup.string().required("Açıklama alanını doldurunuz"),
    }),
    onSubmit: async (values) => {
      try {
        // Malzeme kaydını (Recipe_Products_GR dahil) oluşturan yardımcı.
        const buildRecipeProduct = (ing, recipeId) => {
          const prod = getProductList.find(p => String(p.value) === String(ing.product_id));
          const input = parseFloat(ing.amount);
          const payload = {
            Products2_ID: parseInt(ing.product_id),
            Recipes_ID: recipeId,
            Products_Unit_Input: input,
          };
          // Web'deki alışveriş listesi hesabı için gram karşılığını da yazalım.
          if (prod && prod.amount != null) {
            const piece = prod.piece && Number(prod.piece) !== 0 ? Number(prod.piece) : 1;
            payload.Recipe_Products_GR = Math.round((Number(prod.amount) / piece) * input);
          }
          return payload;
        };

        // Galeri görsellerini senkronize eder: formdan kaldırılanları siler,
        // yeni yüklenenleri Recipes_ImageNew tablosuna yazar.
        const saveGalleryImages = async (recipeId) => {
          const original = (getEditSlider && getEditSlider.Recipes_ImageNew) || [];
          const keptIds = new Set(getGalleryImages.filter(g => g.ID).map(g => g.ID));
          for (const img of original) {
            if (!keptIds.has(img.ID)) {
              await axios.delete(`https://buharaapi.stechomeyazilim.info/Recipes_ImageNew(${img.ID})`);
            }
          }
          for (const g of getGalleryImages) {
            if (!g.ID) {
              await axios.post(`https://buharaapi.stechomeyazilim.info/Recipes_ImageNew`, {
                Recipes_Image_Text: g.name,
                Recipes_ID: recipeId,
              });
            }
          }
        };

        // Malzeme ve adımları backend'e yazan ortak fonksiyon.
        const saveIngredientsAndSteps = async (recipeId) => {
          for (const ing of values.ingredients) {
            if (ing.product_id && ing.amount) {
              await axios.post(`https://buharaapi.stechomeyazilim.info/Recipes_Products`, buildRecipeProduct(ing, recipeId));
            }
          }
          for (let i = 0; i < values.steps.length; i++) {
            if (values.steps[i] && values.steps[i].trim() !== "") {
              await axios.post(`https://buharaapi.stechomeyazilim.info/Recipes_Making`, {
                Recipes_Making_Title: values.steps[i],
                Recipes_Making_Sort: i + 1,
                Recipes_ID: recipeId,
              });
            }
          }
        };

        if (isEdit) {
           const recipeId = order ? order.ID : 0;
           // 1) Ana bilgileri güncelle (kategori + besin değerleri dahil).
           const updateData = {
              ID: recipeId,
              Recipes_Title: values.recipesName,
              Recipes_Desc: values.longDesc,
              Recipes_Image: getFileNameLogo,
              Recipes_Preparation_Time: values.prepationTime ? parseInt(values.prepationTime) : null,
              Recipes_ShortText: values.shortDesc,
              Recipes_Cooking_Time: values.cookingTime ? parseInt(values.cookingTime) : null,
              Recipes_Category_ID: values.categoryId ? parseInt(values.categoryId) : null,
              Recipes_Energy: values.energy !== "" ? parseInt(values.energy) : null,
              Recipes_Carbohydrate: values.carbohydrate !== "" ? parseInt(values.carbohydrate) : null,
              Recipes_Protein: values.protein !== "" ? parseInt(values.protein) : null,
              Recipes_Oil: values.oil !== "" ? parseInt(values.oil) : null,
              Recipes_Trend: getIsActiveTrend,
              Recipes_Video: getFileNameVideo,
           };
           await mustPatch(`https://buharaapi.stechomeyazilim.info/Recipes(${recipeId})`, updateData);

           // 2) Malzemeler: mevcut satırlar YERİNDE güncellenir, yeniler eklenir,
           //    formdan çıkarılanlar silinir.
           //    Eskiden tüm malzemeler silinip yeniden yazılıyordu. Recipes_Products
           //    silinince ona bağlı alışveriş listesi kayıtları da (cascade) siliniyordu
           //    ve kullanıcıların listesindeki malzemeler kayboluyordu; bir silme
           //    başarısız olunca da kayıt yarıda kalıp değişiklik siteye yansımıyordu.
           const oldProducts = (getEditSlider && getEditSlider.Recipes_Products) || [];
           const keptRowIds = new Set();
           for (const ing of values.ingredients) {
             if (!ing.product_id || !ing.amount) continue;
             const payload = buildRecipeProduct(ing, recipeId);
             if (ing.row_id && oldProducts.some(p => p.ID === ing.row_id)) {
               keptRowIds.add(ing.row_id);
               await mustPatch(`https://buharaapi.stechomeyazilim.info/Recipes_Products(${ing.row_id})`, payload);
             } else {
               await axios.post(`https://buharaapi.stechomeyazilim.info/Recipes_Products`, payload);
             }
           }
           for (const p of oldProducts) {
             if (!keptRowIds.has(p.ID)) {
               await axios.delete(`https://buharaapi.stechomeyazilim.info/Recipes_Products(${p.ID})`);
             }
           }

           // 3) Adımlar: sıraya göre eşlenir; mevcut adım güncellenir (çevirileri
           //    Recipes_Making_Lang'da korunur), fazlası eklenir/silinir.
           const oldMaking = sortedMaking(getEditSlider);
           const newSteps = values.steps.map(x => (x || "").trim()).filter(Boolean);
           for (let i = 0; i < newSteps.length; i++) {
             const old = oldMaking[i];
             if (old) {
               if (old.Recipes_Making_Title !== newSteps[i] || old.Recipes_Making_Sort !== i + 1) {
                 await mustPatch(`https://buharaapi.stechomeyazilim.info/Recipes_Making(${old.ID})`, {
                   Recipes_Making_Title: newSteps[i],
                   Recipes_Making_Sort: i + 1,
                 });
               }
             } else {
               await axios.post(`https://buharaapi.stechomeyazilim.info/Recipes_Making`, {
                 Recipes_Making_Title: newSteps[i],
                 Recipes_Making_Sort: i + 1,
                 Recipes_ID: recipeId,
               });
             }
           }
           for (const old of oldMaking.slice(newSteps.length)) {
             await axios.delete(`https://buharaapi.stechomeyazilim.info/Recipes_Making(${old.ID})`);
           }
           await saveGalleryImages(recipeId);
           await refreshSite();

           toastr.success("Tarif, malzemeler ve adımlar başarıyla güncellendi!");
           dispatch(onGetRecipes());
        } else {
            // YENİ KAYIT (Excel Mantığı ile Eşzamanlı Ekleme)
            const newRecipe = {
                Recipes_Title: values.recipesName,
                Recipes_Desc: values.longDesc,
                Recipes_Image: getFileNameLogo,
                Recipes_Preparation_Time: values.prepationTime ? parseInt(values.prepationTime) : null,
                Recipes_ShortText: values.shortDesc,
                Recipes_Cooking_Time: values.cookingTime ? parseInt(values.cookingTime) : null,
                Recipes_Category_ID: values.categoryId ? parseInt(values.categoryId) : null,
                Recipes_Energy: values.energy !== "" ? parseInt(values.energy) : null,
                Recipes_Carbohydrate: values.carbohydrate !== "" ? parseInt(values.carbohydrate) : null,
                Recipes_Protein: values.protein !== "" ? parseInt(values.protein) : null,
                Recipes_Oil: values.oil !== "" ? parseInt(values.oil) : null,
                Recipes_Trend: getIsActiveTrend,
                Recipes_Video: getFileNameVideo,
            };

            const response = await axios.post(`https://buharaapi.stechomeyazilim.info/Recipes`, newRecipe);
            const recipeId = response.data.value[0].ID;

            await saveIngredientsAndSteps(recipeId);
            await saveGalleryImages(recipeId);

            await refreshSite();
            toastr.success("Tarif, malzemeler ve adımlarla birlikte başarıyla eklendi!");
            dispatch(onGetRecipes());
        }

        validation.resetForm();
        setModal(false);
      } catch (error) {
        console.error("Kayıt hatası:", error);
        const detail = error?.response?.data?.error?.message || error?.response?.data?.message || error?.message || "";
        toastr.error(`Kayıt sırasında bir hata oluştu; değişiklikler siteye yansımamış olabilir. ${detail}`.trim());
        // Kısmen kaydedilmiş olabilir — panelde son durumu göster.
        dispatch(onGetRecipes());
        return;
      }
    },
  });

  const toggleViewModal = () => setModal1(!modal1);

  const toggle = () => {
    if (modal) {
      setModal(false);
      setOrder(null);
      setEditSlider(null);
      setIsEdit(false);
      setFileNameLogo(null);
      setFileNameVideo(null);
      setGalleryImages([]);
      setIsActiveTrend(false);
    } else {
      setModal(true);
    }
  };

  const handleOrderClick = arg => {
    const orderData = arg;
    setEditSlider(orderData)
    setOrder(orderData);
    setIsEdit(true);
    setIsActiveTrend(orderData.Recipes_Trend === true);
    setFileNameLogo(orderData.Recipes_Image);
    setFileNameMobile(orderData.Recipes_EngImg);
    setFileNameVideo(orderData.Recipes_Video || null);
    setGalleryImages((orderData.Recipes_ImageNew || []).map(img => ({ ID: img.ID, name: img.Recipes_Image_Text })));
    setModal(true);
  };

const handleOrderClicks = () => {
  // Tablo verisini (orderList) ASLA bozmamalıyız.
  // Sadece yeni eklenecek form için state'leri sıfırlıyoruz:
  setOrder(null);
  setEditSlider(null);
  setIsEdit(false);
  setFileNameLogo(null);
  setFileNameVideo(null);
  setGalleryImages([]);
  setIsActiveTrend(false);

  // Modalı aç
  setModal(true);
};
  // --- DİĞER FONKSİYONLAR (Blog/Tekil Güncelleme vs) ---
  const [deleteModal, setDeleteModal] = useState(false);
  const [langModal, setLangModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [getMakinModal, setMakinModal] = useState(false);
  const [getMakingDetail, setMakingDetail] = useState(null);
  const [getProductModal, setProductModal] = useState(false);
  const [getProductDetail, setProductDetail] = useState(null);
  const [getProductText, setProductText] = useState(null);
  const [getProductCheck, setProductCheck] = useState(null);

  const onClickDelete = (order) => {
    setOrder(order);
    setDeleteModal(true);
  };
  
  const handleDeleteOrder = () => {
    if (order && order.ID) {
      dispatch(onDeleteRecipes(order.ID));
      setDeleteModal(false);
    }
  };

  const handleRecipesMaking = (item) => {
      setMakinModal(true);
      setMakingDetail(item)
      setMakingText(item.Recipes_Making_Title)
  };

  const handleRecipesProduct = (item) => {
      setProductModal(true);
      setProductDetail(item)
      if(item.Products != null){
        setProductText(item.Products.Products_Name)
        setProductCheck(1)
      }
      if(item.Products2 != null){
        setProductText(item.Products2.Products_Name)
        setProductCheck(2)
      }
  };

  const _deleteRecipesMaking = async() => {
    try{
       await axios.delete(`https://buharaapi.stechomeyazilim.info/Recipes_Making(${getMakingDetail.ID})`);
       dispatch(onGetRecipes());
       setMakinModal(false);
    }catch (err) { console.log(err); }
  }

  const _updateMakingList = async() => {
    try{
       const updateData = { Recipes_Making_Title: getMakingText }
       await axios.patch(`https://buharaapi.stechomeyazilim.info/Recipes_Making(${getMakingDetail.ID})`, updateData);
       dispatch(onGetRecipes());
       setMakinModal(false);
    }catch (err) { console.log(err); }
  }

  const _deleteRecipesProduct = async() => {
    try{
       await axios.delete(`https://buharaapi.stechomeyazilim.info/Recipes_Products(${getProductDetail.ID})`);
       dispatch(onGetRecipes());
       setProductModal(false);
    }catch (err) { console.log(err); }
  }

  const _updateProductList = async() => {
    try{
       const updateData = { Products_Name: getProductText }
       if(getProductCheck === 1){
         await axios.patch(`https://buharaapi.stechomeyazilim.info/Products(${getProductDetail.ID})`, updateData);
       }else{
         await axios.patch(`https://buharaapi.stechomeyazilim.info/Products2(${getProductDetail.ID})`, updateData);
       }
       dispatch(onGetRecipes());
       setProductModal(false);
    }catch (err) { console.log(err); }
  }

  // Blog modal logic
  const [getAttachedBlogs, setAttachedBlogs] = useState([]); // tarife ekli bloklar
  const toggleAddBlog = () => setIsAddBlog(!getIsAddBlog);
  const handleAddBlog = arg => {
    setOrderBlog(arg);
    setSelectBlog([]);
    _getBlogList();
    // Tarife önceden eklenmiş blogları (blokları) modalda gösterebilmek için ayrı tutuyoruz.
    const current = (arg.Recipes_Blog || [])
      .filter(item => item.Blog)
      .map(item => ({ rowId: item.ID, blogId: item.Blog.ID, title: item.Blog.Blog_Title }));
    setAttachedBlogs(current);
    setIsAddBlog(true);
  };

  const postBlogInRecipes = async() => {
    try{
      if(getSelectBlog.length > 0){
        const existingIds = new Set(getAttachedBlogs.map(b => b.blogId));
        const added = [];
        for(const item of getSelectBlog){
          if (existingIds.has(item.value)) continue; // zaten ekli olanı tekrar ekleme
          const data = { Recipes_ID: getOrderBlog.ID, Blog_ID: item.value };
          const res = await axios.post(`https://buharaapi.stechomeyazilim.info/Recipes_Blog`, data);
          const rowId = res?.data?.value?.[0]?.ID ?? res?.data?.ID;
          if (!rowId) throw new Error("Kayıt numarası alınamadı");
          added.push({ rowId, blogId: item.value, title: item.label });
        }
        if (added.length === 0) {
          toastr.info("Seçilen bloglar zaten ekli.");
          return;
        }
        setAttachedBlogs(prev => [...prev, ...added]);
        setSelectBlog([]);
        dispatch(onGetRecipes());
        await refreshSite();
        toastr.success("Blog(lar) tarife eklendi. Tarif ve blog sayfalarında karşılıklı görünür.");
      }else{
        toastr.warning("Blog seçilmedi.");
      }
    }catch (err) {
      console.log(err);
      toastr.error("Blog tarife eklenemedi.");
      dispatch(onGetRecipes());
    }
  }

  const _deleteRecipesBlog = async(rowId) => {
    try{
      await axios.delete(`https://buharaapi.stechomeyazilim.info/Recipes_Blog(${rowId})`);
      setAttachedBlogs(prev => prev.filter(b => b.rowId !== rowId));
      dispatch(onGetRecipes());
      await refreshSite();
      toastr.success("Blog tariften kaldırıldı.");
    }catch (err) {
      console.log(err);
      toastr.error("Blog tariften kaldırılamadı.");
    }
  }

  // --- EXCEL YÜKLEME ---
  const [uploadModalOpen, setUploadModalOpen] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);

  const arrayBufferToBinaryString = (buffer) => {
    const binaryArray = new Uint8Array(buffer);
    return binaryArray.reduce((data, byte) => data + String.fromCharCode(byte), '');
  };

  const handleFileUpload = async (e) => {
    try {
      const file = e.target.files[0];
      if (!file) return;
      const reader = new FileReader();
  
      reader.onload = async (event) => {
        setUploadModalOpen(true);
        setUploadProgress(0);
  
        const binaryString = arrayBufferToBinaryString(event.target.result);
        const workbook = XLSX.read(binaryString, { type: 'binary' });
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];
        const data = XLSX.utils.sheet_to_json(sheet, { header: 1 });
  
        const headers = data[0];
        const formattedData = data.slice(1).map((row) => {
          const rowData = {};
          row.forEach((cell, index) => { rowData[headers[index]] = cell; });
          return rowData;
        });
  
        const existingCodes = new Set(orders.map((user) => user.Recipes_Title));
        const allProductsRes = await axios.get(`https://buharaapi.stechomeyazilim.info/Products2`);
        const productListEx = allProductsRes.data;
  
        const total = formattedData.length;
  
        for (let index = 0; index < total; index++) {
          const row = formattedData[index];
          if (existingCodes.has(row.tarifadı)) continue;
  
          try {
            const newRecipe = {
              Recipes_Title: row.tarifadı,
              Recipes_Desc: row.tarifaçıklaması,
              Recipes_Preparation_Time: row.hazırlamasüresi,
              Recipes_Cooking_Time: row.pişirmesüresi,
              Recipes_Category_ID: parseInt(row.katID),
              Recipes_IsStory: false,
              Recipes_Trend: false,
            };
  
            const recipeResponse = await axios.post(`https://buharaapi.stechomeyazilim.info/Recipes`, newRecipe);
            const recipeId = recipeResponse.data.value[0].ID;
  
            for (let i = 1; i <= 20; i++) {
              const productCode = row[`id${i}`]?.toString();
              const productAmount = parseFloat(row[`miktar${i}`]);
              if (!productCode || isNaN(productAmount)) continue;
  
              const product = productListEx.find(p => p.Products2_Code === productCode);
              if (product) {
                const recipeProduct = {
                  Products2_ID: product.ID,
                  Products_Unit_ID: product.Products_Units_ID,
                  Recipes_ID: recipeId,
                  Products_Unit_Input: productAmount,
                  Recipe_Products_GR: productAmount * parseInt(product.Products_Amount)
                };
                await axios.post(`https://buharaapi.stechomeyazilim.info/Recipes_Products`, recipeProduct);
              }
            }
  
            for (let i = 1; i <= 11; i++) {
              const stepText = row[i.toString()];
              if (stepText && stepText !== "") {
                const step = {
                  Recipes_Making_Title: stepText.toString(),
                  Recipes_Making_Sort: i,
                  Recipes_ID: recipeId
                };
                await axios.post(`https://buharaapi.stechomeyazilim.info/Recipes_Making`, step);
              }
            }
            setUploadProgress(Math.round(((index + 1) / total) * 100));
          } catch (err) { console.error("Tarif eklenirken hata:", err); }
        }
        setUploadModalOpen(false);
        dispatch(onGetRecipes());
      };
      reader.readAsArrayBuffer(file);
    } catch (err) { console.log(err); }
  };

  const handleClick = () => document.getElementById('fileInput').click();

  const columns = useMemo(
    () => [
      {
        Header: "Tarif Görseli",
        disableFilters: true,
        filterable: true,
        accessor: (cellProps) => (
          <>
            {!cellProps.Recipes_Image ? (
              <div className="avatar-xl">
               {cellProps.Recipes_Title != null ? <span className="avatar-title rounded-circle">{cellProps.Recipes_Title.charAt(0)}</span> : null}
              </div>
            ) : (
              <div><img className=" avatar-xl" src={'https://buharasubdomain.stechomeyazilim.info/' +  cellProps.Recipes_Image} alt="" /></div>
            )}
          </>
        ),
      },
      { Header: 'Tarif Adı', accessor: 'Recipes_Title', disableFilters: true, filterable: true, Cell: (cellProps) => <Name {...cellProps} /> },
      {
        Header: 'Kategori',
        accessor: 'Recipes_Category',
        disableFilters: true,
        filterable: true,
        Cell: (cellProps) => {
          const category = Array.isArray(cellProps.value) ? cellProps.value[0] : cellProps.value;
          return <span>{category?.Recipes_Category_Text || '-'}</span>;
        }
      },
      {
        Header: 'Hazırlama',
        accessor: 'Recipes_Preparation_Time',
        disableFilters: true,
        filterable: true,
        Cell: (cellProps) => <span>{cellProps.value ? `${cellProps.value} dk` : '-'}</span>
      },
      {
        Header: 'Pişirme',
        accessor: 'Recipes_Cooking_Time',
        disableFilters: true,
        filterable: true,
        Cell: (cellProps) => <span>{cellProps.value ? `${cellProps.value} dk` : '-'}</span>
      },
      {
        Header: 'Besin Değerleri',
        accessor: (row) => row,
        disableFilters: true,
        filterable: true,
        Cell: (cellProps) => {
          const row = cellProps.value;
          const parts = [];
          if (row.Recipes_Energy != null) parts.push(`Enerji: ${row.Recipes_Energy} kcal`);
          if (row.Recipes_Carbohydrate != null) parts.push(`Karb: ${row.Recipes_Carbohydrate}g`);
          if (row.Recipes_Protein != null) parts.push(`Prot: ${row.Recipes_Protein}g`);
          if (row.Recipes_Oil != null) parts.push(`Yağ: ${row.Recipes_Oil}g`);
          return <span>{parts.length ? parts.join(' | ') : '-'}</span>;
        }
      },
      {
        Header: 'Malzemeler',
        accessor: 'Recipes_Products',
        disableFilters: true,
        filterable: true,
        Cell: (cellProps) => {
          const products = cellProps.value || [];
          if (!products.length) return <span>-</span>;
          const names = products.map(p =>
            p.Products2?.Products_Name || p.Products?.Products_Name || 'Bilinmeyen Ürün'
          ).filter(Boolean);
          const visible = names.slice(0, 3);
          return (
            <span title={names.join(', ')}>
              {products.length} adet{names.length ? `: ${visible.join(', ')}${names.length > 3 ? ` +${names.length - 3} daha` : ''}` : ''}
            </span>
          );
        }
      },
      {
        Header: 'Adım Sayısı',
        accessor: 'Recipes_Making',
        disableFilters: true,
        filterable: true,
        Cell: (cellProps) => <span>{cellProps.value?.length || 0}</span>
      },
      {
        Header: 'Trend',
        accessor: 'Recipes_Trend',
        disableFilters: true,
        filterable: true,
        Cell: (cellProps) => (
          <span className={`badge ${cellProps.value ? 'bg-success' : 'bg-secondary'}`}>
            {cellProps.value ? 'Evet' : 'Hayır'}
          </span>
        )
      },
      { Header: 'Tarif Açıklama', accessor: 'Recipes_Desc', disableFilters: true, filterable: true, Cell: (cellProps) => <Name {...cellProps} /> },
      {
        Header: 'İşlemler',
        accessor: 'action',
        disableFilters: true,
        Cell: (cellProps) => {
          return (
            <div className="d-flex gap-3">
              <Link to="#" className="text-danger" onClick={() => handleAddBlog(cellProps.row.original)}>Blog Ekle</Link>
              <Link to="#" className="text-success" onClick={() => handleOrderClick(cellProps.row.original)}>
                <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
                <UncontrolledTooltip placement="top" target="edittooltip">Düzenle</UncontrolledTooltip>
              </Link>
              <Link to="#" className="text-info" onClick={() => { setSelectedItem(cellProps.row.original); setLangModal(true); }}>
                <i className="mdi mdi-translate font-size-18" id="langtooltip-recipe" />
                <UncontrolledTooltip placement="top" target="langtooltip-recipe">Çeviriler</UncontrolledTooltip>
              </Link>
              <Link to="#" className="text-danger" onClick={() => onClickDelete(cellProps.row.original)}>
                <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
                <UncontrolledTooltip placement="top" target="deletetooltip">Sil</UncontrolledTooltip>
              </Link>
            </div>
          );
        }
      },
    ],
    []
  );

  // Video ve galeri için previewUrl gelmeyebilir; sade bir durum satırı gösteriyoruz.
  const FilePreview = ({ meta }) => {
    const { name, percent, status } = meta;
    return (
      <div className="preview-box">
        <span className="name">{name}</span> - <span className="status">{status === "done" ? "Başarıyla Yüklendi" : "Yükleniyor"}</span>{status !== "done" && <span className="percent"> ({Math.round(percent)}%)</span>}
      </div>
    )
  }

  const Preview = ({ meta }) => {
    const { name, percent, status, previewUrl } = meta;
    return (
      <div className="preview-box">
        <img src={previewUrl} alt="" /> <span className="name">{name}</span> - <span className="status">{status === "done" ? "Başarıyla Yüklendi" : "Yükleniyor"}</span>{status !== "done" && <span className="percent"> ({Math.round(percent)}%)</span>}
      </div>
    )
  }

  return (
    <React.Fragment>
      <EcommerceOrdersModal isOpen={modal1} toggle={toggleViewModal} />
      <LangModal
        isOpen={langModal}
        toggle={() => setLangModal(false)}
        title="Tarif"
        tableName="Recipes_Lang"
        renderExtra={(lang) => <RecipeStepsLang recipeId={selectedItem?.ID} lang={lang} />}
        foreignKey="Recipes_ID"
        foreignKeyValue={selectedItem?.ID}
        sourceRecord={selectedItem}
        fields={[
          { name: 'Recipes_Image', label: 'Görsel', type: 'image' },
          { name: 'Recipes_Title', label: 'Başlık', type: 'text' },
          { name: 'Recipes_Desc', label: 'Açıklama', type: 'textarea' },
          { name: 'Recipes_Video', label: 'Video (boş bırakılırsa ana video kullanılır)', type: 'video' },
        ]}
      />
      <DeleteModal show={deleteModal} onDeleteClick={handleDeleteOrder} onCloseClick={() => setDeleteModal(false)} />

      <Modal isOpen={uploadModalOpen} backdrop="static" centered>
        <ModalBody>
          <p className="text-center text-lg font-bold mb-3">Yükleme Devam Ediyor...</p>
          <Progress value={uploadProgress} color="warning" animated />
          <p className="text-center mt-2">{uploadProgress}%</p>
        </ModalBody>
      </Modal>

      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="Yönetim" breadcrumbItem="Tarifler" />
          <PageHint
            what="Yemek tarifleri bu ekrandan yönetilir."
            where="Tarifler sayfasındaki kartlar ve tarif detay sayfaları. Malzemeler, yapılış adımları, besin değerleri, video ve görsel galerisi burada girilir."
            note="Tarif malzemeleri “Tarif Ürünleri” ekranındaki listeden seçilir."
            links={[{ label: 'Tarifler sayfası', path: '/yemek-tarifleri' }]}
          />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <button color="success" className="btn-rounded mb-2 me-2" onClick={handleClick}>Excel Dosyasını Yükle</button>
                  <input id="fileInput" type="file" accept=".xlsx, .xls" style={{ display: 'none' }} onChange={handleFileUpload} />
                  <TableContainer
                    columns={columns}
                    data={orderList}
                    isGlobalFilter={true}
                    isAddRecipes={true}
                    handleOrderClicks={handleOrderClicks}
                    customPageSize={10}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>

          {/* ANA EKLEME/DÜZENLEME MODALI */}
          <Modal isOpen={modal} toggle={toggle} size="lg">
            <ModalHeader toggle={toggle} tag="h4">
              {!!isEdit ? "Tarifi Düzenle" : "Tarif Ekle"}
            </ModalHeader>
            <ModalBody style={{ maxHeight: '75vh', overflowY: 'auto' }}>
              <Form onSubmit={(e) => { e.preventDefault(); validation.handleSubmit(); return false; }}>
                
                {/* 1. TARİF TEMEL BİLGİLERİ */}
                <h5 className="mb-3 text-primary">Temel Bilgiler</h5>
                <Row>
                  <Col md={6}>
                    <div className="mb-3">
                      <Label className="form-label">Tarif Adı</Label>
                      <Input name="recipesName" type="text" placeholder="Tarif Adı" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.recipesName || ""} invalid={validation.touched.recipesName && validation.errors.recipesName ? true : false} />
                      {validation.touched.recipesName && validation.errors.recipesName ? (<FormFeedback type="invalid">{validation.errors.recipesName}</FormFeedback>) : null}
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="mb-3">
                      <Label className="form-label">Kısa Açıklama</Label>
                      <Input name="shortDesc" type="text" placeholder="Kısa Açıklama" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.shortDesc || ""} />
                    </div>
                  </Col>
                  <Col md={12}>
                    <div className="mb-3">
                      <Label className="form-label">Detaylı Açıklama</Label>
                      <Input name="longDesc" type="textarea" rows="3" placeholder="Detaylı Açıklama" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.longDesc || ""} invalid={validation.touched.longDesc && validation.errors.longDesc ? true : false} />
                      {validation.touched.longDesc && validation.errors.longDesc ? (<FormFeedback type="invalid">{validation.errors.longDesc}</FormFeedback>) : null}
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="mb-3">
                      <Label className="form-label">Hazırlama Süresi (Dk)</Label>
                      <Input name="prepationTime" type="number" placeholder="Örn: 15" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.prepationTime || ""} />
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="mb-3">
                      <Label className="form-label">Pişirme Süresi (Dk)</Label>
                      <Input name="cookingTime" type="number" placeholder="Örn: 30" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.cookingTime || ""} />
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="mb-3">
                      <Label className="form-label">Kategori</Label>
                      <select className="form-select" name="categoryId"
                        value={validation.values.categoryId || ""}
                        onChange={(e) => validation.setFieldValue("categoryId", e.target.value)}>
                        <option value="">Kategori Seçiniz...</option>
                        {getCategoryList?.map(c => <option key={c.value} value={c.value}>{c.label}</option>)}
                      </select>
                    </div>
                  </Col>
                </Row>

                {/* BESİN DEĞERLERİ */}
                <hr />
                <h5 className="mb-3 text-primary">Besin Değerleri</h5>
                <Row>
                  <Col md={3}>
                    <div className="mb-3">
                      <Label className="form-label">Enerji (kcal)</Label>
                      <Input name="energy" type="number" placeholder="Örn: 250" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.energy ?? ""} />
                    </div>
                  </Col>
                  <Col md={3}>
                    <div className="mb-3">
                      <Label className="form-label">Karbonhidrat (g)</Label>
                      <Input name="carbohydrate" type="number" placeholder="Örn: 30" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.carbohydrate ?? ""} />
                    </div>
                  </Col>
                  <Col md={3}>
                    <div className="mb-3">
                      <Label className="form-label">Protein (g)</Label>
                      <Input name="protein" type="number" placeholder="Örn: 12" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.protein ?? ""} />
                    </div>
                  </Col>
                  <Col md={3}>
                    <div className="mb-3">
                      <Label className="form-label">Yağ (g)</Label>
                      <Input name="oil" type="number" placeholder="Örn: 8" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.oil ?? ""} />
                    </div>
                  </Col>
                </Row>

                {/* 2. MALZEMELER */}
                <hr />
                <h5 className="mb-3 text-primary">Malzemeler</h5>
                {validation.values.ingredients.map((ingredient, index) => (
                  <Row key={index} className="mb-2 align-items-center">
                    <Col md={7}>
                      <select className="form-select" value={ingredient.product_id} onChange={(e) => {
                          const newIng = validation.values.ingredients.map((it, i) =>
                            i === index ? { ...it, product_id: e.target.value } : it);
                          validation.setFieldValue("ingredients", newIng);
                        }}>
                        <option value="">Ürün Seçiniz...</option>
                        {getProductList?.map(p => <option key={p.value} value={p.value}>{p.label}</option>)}
                      </select>
                    </Col>
                    <Col md={3}>
                      <Input type="number" placeholder="Miktar" value={ingredient.amount} onChange={(e) => {
                          const newIng = validation.values.ingredients.map((it, i) =>
                            i === index ? { ...it, amount: e.target.value } : it);
                          validation.setFieldValue("ingredients", newIng);
                        }} />
                    </Col>
                    <Col md={2}>
                      <button type="button" className="btn btn-outline-danger btn-sm" onClick={() => {
                        const newIng = validation.values.ingredients.filter((_, i) => i !== index);
                        validation.setFieldValue("ingredients", newIng);
                      }}>Kaldır</button>
                    </Col>
                  </Row>
                ))}
                <button type="button" className="btn btn-soft-success btn-sm mb-4 mt-2" onClick={() => {
                  validation.setFieldValue("ingredients", [...validation.values.ingredients, { product_id: '', amount: '' }]);
                }}>+ Malzeme Ekle</button>

                {/* 3. HAZIRLANIŞ ADIMLARI */}
                <hr />
                <h5 className="mb-3 text-primary">Hazırlanış Adımları</h5>
                {validation.values.steps.map((step, index) => (
                  <div key={index} className="d-flex mb-3 align-items-start">
                    <span className="me-3 mt-2 fw-bold">{index + 1}.</span>
                    <Input type="textarea" rows="2" value={step} placeholder="Adım detayını yazınız..." onChange={(e) => {
                        const newSteps = [...validation.values.steps];
                        newSteps[index] = e.target.value;
                        validation.setFieldValue("steps", newSteps);
                      }} />
                    <button type="button" className="btn btn-link text-danger ms-2" onClick={() => {
                      const newSteps = validation.values.steps.filter((_, i) => i !== index);
                      validation.setFieldValue("steps", newSteps);
                    }}>Kaldır</button>
                  </div>
                ))}
                <button type="button" className="btn btn-soft-success btn-sm mb-4" onClick={() => {
                  validation.setFieldValue("steps", [...validation.values.steps, '']);
                }}>+ Adım Ekle</button>

                {/* 4. GÖRSEL VE DİĞER AYARLAR */}
                <hr />
                <h5 className="mb-3 text-primary">Görseller ve Ayarlar</h5>
                <Row>
                  <Col md={6}>
                    <Label className="form-label">Trend Tarif Olarak İşaretle</Label>
                    <div className="square-switch mb-3">
                      <input type="checkbox" id="square-switch1" className="switch" checked={getIsActiveTrend} onChange={() => setIsActiveTrend(!getIsActiveTrend)} />
                      <label htmlFor="square-switch1" data-on-label="Evet" data-off-label="Hayır" />
                    </div>
                    <p className="text-muted small mt-n2">Sitedeki &quot;Trend Tarifler&quot; sıralamasında öne çıkar ve kartta trend rozeti gösterilir. Mobil uygulamada anasayfadaki &quot;Öne Çıkan Tarifler&quot; şeridinde yer alır.</p>
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} className="mb-4">
                    <label>Tarif Görseli (800x600)</label>
                    <Dropzone getUploadParams={getUploadParams} onChangeStatus={handleChangeStatusLogo} maxFiles={1}
                      styles={{ dropzone: { overflow: 'auto', border: '1px dashed #999', background: '#f8f9fa' } }}
                      canRemove={false} PreviewComponent={Preview} accept="image/*" />
                    {getFileNameLogo && (
                      <div className="mt-2"><img className="rounded shadow-sm" style={{maxHeight:'100px'}} src={'https://buharasubdomain.stechomeyazilim.info/' + getFileNameLogo} alt="Mevcut Görsel" /></div>
                    )}
                  </Col>
                </Row>

                {/* 5. TARİF MEDYASI: TEK VİDEO + SINIRSIZ GALERİ GÖRSELİ */}
                <hr />
                <h5 className="mb-3 text-primary">Tarif Medyası</h5>
                <Row>
                  <Col xs={12} className="mb-4">
                    <label>Tarif Videosu (tek video, mp4 önerilir)</label>
                    <Dropzone getUploadParams={getUploadParams} onChangeStatus={handleChangeStatusVideo} maxFiles={1}
                      styles={{ dropzone: { overflow: 'auto', border: '1px dashed #999', background: '#f8f9fa' } }}
                      canRemove={false} PreviewComponent={FilePreview} accept="video/*" />
                    {getFileNameVideo && (
                      <div className="mt-2">
                        <video
                          className="rounded shadow-sm"
                          style={{ maxHeight: '180px', maxWidth: '100%' }}
                          src={'https://buharasubdomain.stechomeyazilim.info/' + getFileNameVideo}
                          controls
                        />
                        <div>
                          <button type="button" className="btn btn-sm btn-outline-danger mt-2" onClick={() => setFileNameVideo(null)}>
                            Videoyu Kaldır
                          </button>
                        </div>
                      </div>
                    )}
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} className="mb-4">
                    <label>Tarif Görselleri (adet sınırı yok)</label>
                    <Dropzone getUploadParams={getUploadParams} onChangeStatus={handleChangeStatusGallery} multiple={true}
                      styles={{ dropzone: { overflow: 'auto', border: '1px dashed #999', background: '#f8f9fa' } }}
                      canRemove={false} PreviewComponent={Preview} accept="image/*"
                      inputContent="Görselleri buraya sürükleyin ya da seçin (birden fazla seçebilirsiniz)" />
                    {getGalleryImages.length > 0 ? (
                      <div className="d-flex flex-wrap gap-2 mt-3">
                        {getGalleryImages.map((img, index) => (
                          <div key={`${img.ID || 'new'}-${index}`} className="position-relative border rounded p-1">
                            <img className="rounded" style={{ height: '90px', width: '90px', objectFit: 'cover' }}
                              src={'https://buharasubdomain.stechomeyazilim.info/' + img.name} alt={`Tarif görseli ${index + 1}`} />
                            <button type="button" className="btn btn-sm btn-outline-danger w-100 mt-1"
                              onClick={() => setGalleryImages(prev => prev.filter((_, i) => i !== index))}>
                              Kaldır
                            </button>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <p className="text-muted mt-2 mb-0">Henüz görsel eklenmedi.</p>
                    )}
                  </Col>
                </Row>

                <div className="text-end pt-3 border-top">
                  <button type="button" className="btn btn-light me-2" onClick={toggle}>İptal</button>
                  <button type="submit" className="btn btn-success">
                     {isEdit ? "Değişiklikleri Kaydet" : "Tümünü Kaydet (Tarif + Ürünler + Adımlar)"}
                  </button>
                </div>
              </Form>
            </ModalBody>
          </Modal>

          {/* DİĞER TEKİL DÜZENLEME MODALLARI (SİLİNMEYİP KORUNDU) */}
          <Modal isOpen={getIsAddBlog} toggle={toggleAddBlog}>
            <ModalHeader toggle={toggleAddBlog} tag="h4">Blog Ekle</ModalHeader>
            <ModalBody>
              {/* Tarife ekli mevcut bloklar (görme + kaldırma) */}
              <Label className="form-label">Ekli Bloglar</Label>
              {getAttachedBlogs.length > 0 ? (
                <ul className="list-group mb-3">
                  {getAttachedBlogs.map(b => (
                    <li key={b.rowId} className="list-group-item d-flex justify-content-between align-items-center">
                      <span>{b.title}</span>
                      <button type="button" className="btn btn-sm btn-outline-danger" onClick={() => _deleteRecipesBlog(b.rowId)}>Kaldır</button>
                    </li>
                  ))}
                </ul>
              ) : (
                <p className="text-muted mb-3">Bu tarife henüz blog eklenmemiş.</p>
              )}

              <Form onSubmit={(e) => { e.preventDefault(); postBlogInRecipes(); }}>
                <Label className="form-label">Yeni Blog Ekle</Label>
                <MultiSelectOption handleChange={(val) => setSelectBlog(val)} fullData={getBlogList} value={getSelectBlog} type={"blog"} />
                <div className="text-end mt-3"><button type="submit" className="btn btn-success">Kaydet</button></div>
              </Form>
            </ModalBody>
          </Modal>
          
        </div>
      </div>
    </React.Fragment>
  );
}

EcommerceOrder.propTypes = { preGlobalFilteredRows: PropTypes.any };
export default EcommerceOrder;